import { gql, useMutation } from '@apollo/client';

import { GET_OWN_DATA } from './get-own-data.hook';
import { GET_EMPLOYEE_BY_ID } from './get-employee-by-id.hook';

export const UPDATE_OWN_DATA = gql`
  mutation memberOwnDataUpdate($payload: UpdateOwnMemberDataInput!) {
      memberOwnDataUpdate(payload: $payload) {
      _id
    }
  }
`;

export const useEmployeeOwnDataUpdate = ({ onSuccess }: { onSuccess?: () => void }) => {
  const [memberOwnDataUpdate] = useMutation(UPDATE_OWN_DATA, {
    onCompleted: data => {
      if (onSuccess && data) {
        onSuccess();
      }
    },
    refetchQueries: [GET_OWN_DATA, GET_EMPLOYEE_BY_ID],
  });

  return memberOwnDataUpdate;
};
